


























































import { Vue, Component } from 'vue-property-decorator';
import authService from '@/services/authentication.service';
import { axiosService } from '../services/axios.service';

@Component({})
export default class Login extends Vue {
  // loginStatus = 1;
  public loginError = false;
  public loginForm = {
    login: '',
    password: ''
  };

  public login() {
    authService
      .login({ email: this.loginForm.login, password: this.loginForm.password })
      .then((response: any) => {
        localStorage.setItem('token', response.data.token);
        axiosService.setInterceptor();
        if (response.data.isOnetimePassword) {
          this.$router.push('/reset-password');
        } else {
          this.$router.push('/');
        }
      })
      .catch((error: Error) => {
        // tslint:disable-next-line
        console.error(error);
        this.loginError = true;
      });
  }
}

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
